<template lang="pug">
  .component-reservation-action-buttons(v-if="entity")
    ul.dropdown.menu(v-if="item", data-dropdown-menu='', v-f="")
      li
        a(href='#Item-1') Action
        ul.menu
          li
            a(v-on:click="open") Open
          li
            a(v-on:click="close") Close
          li
            PreauthReveal(:reservation="entity")
          li
            TerminateReservationReveal(:entity="entity")
          li
            a(@click="extend") Extend
          li
            a(v-on:click="voidR") Void
          li
            a(v-on:click="cancel") Cancel
          li
            a(v-on:click="resend") Force Resend
          li
            a(v-on:click="cleanup") Cleanup
          li
            ChargingSessionReveal(:reservation="entity" )
          li
            router-link(:to="{path:'report-reservation', params:{id:item.id}}") Report
          li
            ActionButton(:action="reconciliate")
              a Reconciliate charged cost

          li
            ActionButton(:action="complete", saveLabel="Mark as completed")
              .row(slot="prompt" )
                .column
                  h2 Mark R{{entity.number}} as completed
                  label Strategy
                    select(v-model="strategy")
                      option(value="original_end") End as the booked end
                      option(value="first_end_sent") First end sent
                      option(value="user_defined") Custom
                  .user-defined(v-if="strategy === 'user_defined'")
                    label Select Date
                    DatePicker(:pickTime="true", format="yyyy-mm-dd hh:ii", v-model="value")
                  template(v-if="entity.booking_mode === 'OWFF'")
                    label End on selected parking lot
                    SelectizeParkingLot(v-model="extra.owff_dropoff_parking_lot")
              a Mark as completed
          li
            a(v-on:click="edit") Edit
          li
            a(v-on:click="findReplace") Find a replace vehicle

    .dropdown-buttons(v-else)
      button.button.success(v-on:click="open") Open
      button.button.warning(v-on:click="close") Close
      button.button.alert(@click="voidR") Void
      button.button.warning(v-on:click="cancel") Cancel
      button.button.warning(v-on:click="resend") Force resend
      ReservationUncoveredAmountReveal


</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import MaggieHelper from 'src/maggieHelper'
import ReservationSmartEdit from '../../../backoffice/smartedits/ReservationEdit'
import ActionButton from '../ActionButton'
import SelectizeParkingLot from '../lists/selectize/SelectizeParkingLot'
import ReservationUncoveredAmountReveal from '../../../../pages/backoffice/ReservationUncoveredAmount'
import TerminateReservationReveal from "./TerminateReservationReveal.vue";
import ChargingSessionReveal from "../../../../pages/backoffice/ChargingSessionReveal.vue";
import DatePicker from "../../DatePicker.vue";
import PreauthReveal from "../../../../pages/backoffice/PreauthReveal.vue";

export default {
  name: 'ReservationActionButtons',
  components: {
    PreauthReveal,
    ChargingSessionReveal,
    TerminateReservationReveal,
    ReservationUncoveredAmountReveal,
    SelectizeParkingLot,
    DatePicker,
    ActionButton
  },
  data() {
    return {
      strategy: null,
      value: null,
      entity: null,
      extra: {
        owff_dropoff_parking_lot: null
      },
      extendComponent: require('../../../backoffice/ExtendReservation'),
      completeAsOriginalEnd: false,
      completeModal: false,
    }
  },
  created() {
    if (!this.reservation) {
      KeplerBackofficeSdk.reservations.select(this.$route.params.id).get((item) => {
        this.entity = item
      })

    } else {
      this.entity = this.reservation
    }
  },
  methods: {
    open() {
      KeplerBackofficeSdk.reservations.select(this.entity.number).open(function () {
        MaggieHelper.notification('open-esit', 'vehicle open signal sent')
      })
    },
    close() {
      KeplerBackofficeSdk.reservations.select(this.entity.number).close(function () {
        MaggieHelper.notification('close-esit', 'vehicle close signal sent')
      })
    },
    voidR() {
      this.$confirm('Are you sure?', 'Do you really want to <strong>Void</strong> the reservation <strong>' + this.entity.number + '</strong>?', () => {
        KeplerBackofficeSdk.reservations.select(this.entity.number).void(function () {
          MaggieHelper.notification('void-esit', 'reservation voided')
        })
      })
    },
    complete() {
      let value = null
      if (this.value !== null) {
        value = this.$convertTimestamp(this.value)
      }

      return KeplerBackofficeSdk.reservations.select(this.entity.number).complete({
        strategy: this.strategy,
        value: value,
        extra: this.extra
      }, function () {
        MaggieHelper.notification('complete-esit', 'reservation completed')
      })
    },
    cancel() {
      this.$confirm('Are you sure?', 'Do you really want to <strong>Cancel</strong> the reservation <strong>' + this.entity.number + '</strong>?', () => {
        KeplerBackofficeSdk.reservations.select(this.entity.number).cancel(function () {
          MaggieHelper.notification('cancel-esit', 'reservation cancelled')
        })
      })
    },
    resend() {
      this.$confirm('Are you sure?', 'Do you really want to <strong>Force resend</strong> the reservation <strong>' + this.entity.number + '</strong>?', () => {
        KeplerBackofficeSdk.reservations.select(this.entity.number).resend(function () {
          MaggieHelper.notification('resend-esit', 'reservation sent')
        })
      })
    },
    extend() {
      MaggieHelper.openTopPanel({
        component: this.extendComponent,
        props: {
          reservation: this.entity,
        }
      })
    },
    findReplace() {
      this.$router.push({name: 'replace-vehicle'})
    },
    edit() {
      MaggieHelper.openRightPanel({
        component: ReservationSmartEdit,
        props: {
          item: this.entity
        }
      })
    },
    reconciliate() {
      return KeplerBackofficeSdk.reservations.select(this.entity.number).reconciliate(() => {
        MaggieHelper.notification('Reconciliation', 'Reservation has been processed')
      })
    },
    uncoveredAmount() {
      return KeplerBackofficeSdk.reservations.select(this.entity.number).uncoveredAmount((data) => {

        alert(data.uncovered_amount)
      })
    },
    cleanup() {
      return KeplerBackofficeSdk.reservations.select(this.entity.number).cleanUp((data) => {
        MaggieHelper.notification('Cleanup', 'Cleanup command sent to vehicle')
      })
    }
  },
  computed: {
    canBeReplaced() {
      return (this.entity.status === 'CONFIRMED' || this.entity.status === 'STARTED' || this.entity.status === 'PLANNED' || this.entity.status === 'SENT') && this.entity.booking_mode === 'RT'
    }
  },
  props: ['reservation', 'item']
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-reservation-action-buttons
  .dropdown
    margin-bottom: 2em

    ul.menu
      border: none
      border-radius: 10px

      li:not(:empty)
        border-bottom: 1px solid #dedede

      li:first-child
        &:hover
          border-bottom-left-radius: 0
          border-bottom-right-radius: 0

      li:last-child
        border-bottom: none
        border-bottom-left-radius: 10px
        border-bottom-right-radius: 10px

        &:hover
          border-top-left-radius: 0
          border-top-right-radius: 0
      //background: yellow


      li:hover
        background: #5EB9CF
        border-radius: 10px

      li:hover:not(:first-child):not(:last-child)
        border-radius: 0

//.button
  text-align: left
  background: none
  color: black
</style>



// WEBPACK FOOTER //
// ReservationActionButtons.vue?cbf71252